// src/components/ProcessId.js
import { useEffect } from "react";
import incode from "../services/incode"; // Asegúrate de que la ruta sea correcta

const ProcessId = ({ session, onSuccess }) => {
  useEffect(() => {
    incode.processId({ token: session.token }).then(() => {
      onSuccess();
    });
  }, [onSuccess, session]);

  return <p>Procesando...</p>;
};

export default ProcessId;
